module.exports = __webpack_public_path__ + "img/bannerAbout.c84d60cf.svg";